import { render, staticRenderFns } from "./NoFind.vue?vue&type=template&id=396bf145&scoped=true&"
import script from "./NoFind.vue?vue&type=script&lang=js&"
export * from "./NoFind.vue?vue&type=script&lang=js&"
import style0 from "./NoFind.vue?vue&type=style&index=0&id=396bf145&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396bf145",
  null
  
)

export default component.exports